<template>
  <v-card  color="white" light elevation="0">
    <div class="custom-heading" color="warning">
        <h3>Acceso</h3>
    </div><!-- .custom-heading.left end -->
    <!-- panel1 dos botones: formulas y sustancias -->
    <v-container id="panel1" v-if="logueado">
      <v-row align="center" content-center style="height: 5%" class="pb-3">
        <v-col cols="12" sm="12" align="center" class="pt-3">
          <a href="http://rapipana.dyndns.org:9696/versionesnew/pana-XLS.zip" target="_blank">
          <strong>descarga Lista de precios Excel (click aquí)</strong>
          </a>
        </v-col>
        <v-col cols="12" sm="12" align="center" class="pt-3">
          <a href="http://rapipana.dyndns.org:9696/versionesnew/pana-DBF.zip" target="_blank">
          <strong>descarga Lista de precios Dbf (click aquí)</strong>
          </a>
        </v-col>
        <v-col cols="12" sm="12" align="center" class="pt-3">
          <a href="http://rapipana.dyndns.org:9696/versionesnew/pana-DBFCR.zip" target="_blank">
          <strong>descarga Lista de precios Dbf con Rubro (click aquí)</strong>
          </a>
        </v-col>
      </v-row>
    </v-container>
    <!-- fin de panel1 -->
    <v-container id="panel2" v-if="!logueado">
      <v-row>
        <v-col>
          <v-alert
            border="left"
            dense
            icon="mdi-account"
            outlined
            prominent
            text
            type="warning"
            class="mp-4"
          >
            <br/>
            Si todavía no tenés tu USUARIO y CONTRASEÑA mandanos un mail a pana@pana.com.ar con tu número de cliente.
            <br/>
            <br/>
          </v-alert>          
          <br/>
          <br/>
          <v-form
            ref="formLoginNitro"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              v-model="usuariologinNitro"
              :counter="50"
              :rules="usuarioReglas"
              label="Usuario"
              required
              outlined
              clearable      
            ></v-text-field>
            <br />
            <v-text-field
              v-model="passwordloginNitro"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :counter="10"
              :rules="passwordReglas"
              :type="show1 ? 'text' : 'password'"
              label="Contraseña"
              @click:append="show1 = !show1"
              required
              outlined
              clearable      
            ></v-text-field>
            <v-container id="panelerroringreso" v-if="erroringresovisible">
              <v-row align="center" content-center style="height: 5%" class="pb-3">
                <v-col cols="12" sm="12" md="6" align="center">
                  <v-alert
                    border="left"
                    dense
                    icon="mdi-close"
                    outlined
                    text
                    type="error"
                    class="mp-4"
                  >
                    Usuario y/o contraseña invalídos
                  </v-alert>                      
                </v-col>
              </v-row>
            </v-container>
            <br /><br />
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="ingresar"
            >
              Ingresar
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-card>    
</template>

<script>
import axios from "axios";

  export default {
    data: () => ({
      valid: false,
      show1: false,
      logueado: false,
      botonhabilitado: true,
      erroringresovisible: false,
      usuariologinNitro: '',
      usuarioReglas: [
        v => !!v || 'ingrese su nombre de usuario',
        v => (v && v.length <= 50) || 'Debe ser de menos de 50 caracteres',
      ],
      passwordloginNitro: '',
      passwordReglas: [
        v => !!v || 'ingrese su contraseña',
        v => (v && v.length <= 10 && v.length >3) || 'Debe tener entre 4 y 10 caracteres',
      ],
    }),
    
    created () {
      this.usuariologinNitro = '';
      this.passwordloginNitro = '';
      this.botonhabilitado = true;
      this.logueado= false;
      this.erroringresovisible=false;
      this.resultados = [];
    },

    methods: {
      validate () {
        this.$refs.formLoginNitro.validate();
      },

      initialize(){
      },

      close () {
          //this.dialog = false;
      },

      async ingresar() {

        this.$refs.formLoginNitro.validate();

        if ( this.usuariologinNitro.trim()=='' || this.passwordloginNitro.trim()=='' ) {
          return false;
        }

        // if ( !this.validate() ) {
        // console.log('======== 02 ========');
        //   return false;
        // }
        this.resultados = [];
        const response = await axios.post('api/UsuariosCadi/Validar', {email: this.usuariologinNitro.trim(), password: this.passwordloginNitro.trim(), version: 5 });

        this.logueado=false;
        this.erroringresovisible=true;
        this.resultados=response.data;

        if ( this.resultados.token == 'ERROR' ) {
          this.logueado=false;
          this.erroringresovisible=true;
          //return false;
        }
        else
        {
          this.logueado=true;
          this.erroringresovisible=false;
          //return true;
        }
      },
    },
  }
</script>
<style scoped src="../estilos/style.css">
</style>
